var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"error-message"},[(_vm.message)?_c('h1',[_vm._v(_vm._s(_vm.message))]):_vm._e(),_c('h1',[_vm._v("404")]),_c('h1',[_vm._v("We Couldn't Find This Page")])])])}
var staticRenderFns = []

export { render, staticRenderFns }